import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { IndianRupee, ShoppingBag, Clock, Sparkles, CheckCircle2, AlertTriangle, TrendingUp, Cpu } from "lucide-react";

const CARDS = [
  ["total_orders", "Total Orders", ShoppingBag, "text-navy"],
  ["revenue", "Revenue (₹)", IndianRupee, "text-gold-hover"],
  ["paid_orders", "Paid Orders", CheckCircle2, "text-emerald-600"],
  ["pending_payments", "Pending Payments", Clock, "text-amber-600"],
  ["awaiting_generation", "Awaiting Generation", Clock, "text-sky-600"],
  ["generating", "Generating", Sparkles, "text-violet-600"],
  ["scheduled", "Scheduled", Clock, "text-indigo-600"],
  ["delivered", "Delivered", CheckCircle2, "text-emerald-600"],
  ["failed_reports", "Failed Reports", AlertTriangle, "text-rose-600"],
  ["refunded", "Refunded", TrendingUp, "text-slate-600"],
  ["avg_order_value", "Avg Order (₹)", IndianRupee, "text-navy"],
  ["email_failures", "Email Failures", AlertTriangle, "text-rose-600"],
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-3xl text-navy mb-1">Dashboard</h1>
      <p className="text-slate-500 text-sm mb-8">Order lifecycle overview and business metrics.</p>
      {!stats ? <p className="text-slate-400">Loading…</p> : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {CARDS.map(([key, label, Icon, color]) => (
              <div key={key} data-testid={`stat-${key}`} className="bg-white rounded-xl border border-slate-200 p-5">
                <Icon className={`w-5 h-5 mb-3 ${color}`} />
                <p className="text-2xl font-semibold text-slate-900">
                  {typeof stats[key] === "number" ? stats[key].toLocaleString() : stats[key]}
                </p>
                <p className="text-xs text-slate-500 mt-1">{label}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 bg-white rounded-xl border border-slate-200 p-5 flex items-center gap-4">
            <Cpu className="w-6 h-6 text-violet-600" />
            <div>
              <p className="text-sm text-slate-500">Estimated AI cost across all reports</p>
              <p className="text-xl font-semibold text-slate-900">${stats.ai_cost_usd?.toFixed(4)} USD</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
